exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-group {\n    width: 100% !important;\n}\n\n.error-message {\n    padding-top: 2;\n    color: #f1736a !important;\n}\n\n.has-error >>> .form-control:not(:focus) {\n    border-color: #f1736a !important;\n}\n\n.has-error .form-control-feedback {\n    color: #f1736a !important;\n}\n\n.input-group > * {\n    border: none;\n}\n.glyphicon {\n    width:30px;\n    height:30px;\n    line-height: 40px;\n}\n\n.glyphicon-ok {\n    color: #38B6A0;\n}\n\n/*Make error appear on blur. Prob;em with single input forms*/\n/* .form-group:focus-within .error-message {\n    display: none;\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-template-input/happy-input-template.component.css
// module id = 835
// module chunks = 0